/**
 * @generated SignedSource<<171f06027ff0a03287be880131d62908>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ClipTrimmer_ShareClipMutation$variables = {
  clipId: string;
  emails: ReadonlyArray<string>;
};
export type ClipTrimmer_ShareClipMutation$data = {
  readonly sendClipEmail: {
    readonly ok: boolean;
  } | null;
};
export type ClipTrimmer_ShareClipMutation = {
  response: ClipTrimmer_ShareClipMutation$data;
  variables: ClipTrimmer_ShareClipMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clipId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "emails"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "clipId",
        "variableName": "clipId"
      },
      {
        "kind": "Variable",
        "name": "emails",
        "variableName": "emails"
      }
    ],
    "concreteType": "SendClipEmail",
    "kind": "LinkedField",
    "name": "sendClipEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClipTrimmer_ShareClipMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClipTrimmer_ShareClipMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "adb23bcce9da4c7a70cf34096d43c89f",
    "id": null,
    "metadata": {},
    "name": "ClipTrimmer_ShareClipMutation",
    "operationKind": "mutation",
    "text": "mutation ClipTrimmer_ShareClipMutation(\n  $clipId: ID!\n  $emails: [String!]!\n) {\n  sendClipEmail(clipId: $clipId, emails: $emails) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "b933b2cc581de3c6883043c5d1a060a1";

export default node;
